import { Box, Paper, Typography } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import { colors } from '@/theme'

export interface NavMenuItem {
  id: string
  title: string
}

interface NavMenuProps {
  items: NavMenuItem[]
  onNavigate: (id: string) => void
  title?: string
}

export default function NavMenu({ items, onNavigate, title = 'Navigation Menu' }: NavMenuProps) {
  return (
    <Paper elevation={1} sx={{ overflow: 'auto', border: `1px solid ${colors.border.default}`, borderRadius: '16px' }}>
      <Typography variant='sectionTitle' sx={{ mb: 2, px: 3, pt: 3 }}>
        {title}
      </Typography>

      <Box>
        {items.map((section, index) => (
          <Box
            key={section.id}
            onClick={() => onNavigate(section.id)}
            sx={{
              py: 3,
              px: 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              borderRadius: '6px',
              transition: 'background-color 0.2s',
              borderBottom: index < items.length - 1 ? `1px solid ${colors.grey[200]}` : 'none',
              '&:hover': {
                bgcolor: colors.grey[100]
              }
            }}
          >
            <Typography variant='body1'>• {section.title}</Typography>
            <ChevronRight sx={{ fontSize: '18px', color: colors.text.muted }} />
          </Box>
        ))}
      </Box>
    </Paper>
  )
}
